<div class="ui active centered inline loader" style="margin-top: 30px" *ngIf="isloading; else elseBlock"></div>
<ng-template #elseBlock>
  <div class="data-wrapper" [class.empty-data-wrapper]="!filoData?.tokyoFilo?.firstIn && !filoData?.tokyoFilo?.lastOut">
    <div class="row">
      <!-- <div class="table-header">拠点</div> -->
      <div class="table-header">東京本社</div>
    </div>
    <div *ngIf="filoData?.tokyoFilo?.firstIn || filoData?.tokyoFilo?.lastOut; else noTokyoStaffs">
      <div class="row">
        <div class="table-side-header">最初に出勤した人</div>
        <div class="timestamp-staff timestamp-data">{{ filoData?.tokyoFilo?.firstIn?.staff_name ? filoData?.tokyoFilo?.firstIn?.staff_name : '&nbsp;' }}</div>
        <div class="timestamp-time timestamp-data">{{ filoData?.tokyoFilo?.firstIn?.time_in ? formatTime(filoData?.tokyoFilo?.firstIn?.time_in, 'time') : '&nbsp;' }}</div>
        <div class="timestamp-date timestamp-data">{{ filoData?.tokyoFilo?.firstIn?.time_in ? formatTime(filoData?.tokyoFilo?.firstIn?.time_in, 'date') : '&nbsp;' }}</div>
      </div>
      <div class="row">
        <div class="table-side-header">最後に退勤した人</div>
        <div class="timestamp-staff timestamp-data">{{ filoData?.tokyoFilo?.lastOut?.staff_name ? filoData?.tokyoFilo?.lastOut?.staff_name : '&nbsp;' }}</div>
        <div class="timestamp-time timestamp-data">{{ filoData?.tokyoFilo?.lastOut?.time_out ? formatTime(filoData?.tokyoFilo?.lastOut?.time_out, 'time') : '&nbsp;' }}</div>
        <div class="timestamp-date timestamp-data">{{ filoData?.tokyoFilo?.lastOut?.time_out ? formatTime(filoData?.tokyoFilo?.lastOut?.time_out, 'date') : '&nbsp;' }}</div>
      </div>
    </div>
    <ng-template #noTokyoStaffs>
      <h4>No staffs to show</h4>
    </ng-template>
  </div>
  <div class="data-wrapper" [class.empty-data-wrapper]="!filoData?.sapporoFilo?.firstIn && !filoData?.sapporoFilo?.lastOut">
    <div class="row">
      <!-- <div class="table-header">拠点</div> -->
      <div class="table-header">札幌支店</div>
    </div>
    <div *ngIf="filoData?.sapporoFilo?.firstIn || filoData?.sapporoFilo?.lastOut; else noSapporoStaffs">
      <div class="row">
        <div class="table-side-header">最初に出勤した人</div>
        <div class="timestamp-staff timestamp-data">{{ filoData?.sapporoFilo?.firstIn?.staff_name ? filoData?.sapporoFilo?.firstIn?.staff_name : '&nbsp;' }}</div>
        <div class="timestamp-time timestamp-data">{{ filoData?.sapporoFilo?.firstIn?.time_in ? formatTime(filoData?.sapporoFilo?.firstIn?.time_in, 'time') : '&nbsp;' }}</div>
        <div class="timestamp-date timestamp-data">{{ filoData?.sapporoFilo?.firstIn?.time_in ? formatTime(filoData?.sapporoFilo?.firstIn?.time_in, 'date') : '&nbsp;' }}</div>
      </div>
      <div class="row">
        <div class="table-side-header">最後に退勤した人</div>
        <div class="timestamp-staff timestamp-data">{{ filoData?.sapporoFilo?.lastOut?.staff_name ? filoData?.sapporoFilo?.lastOut?.staff_name : '&nbsp;' }}</div>
        <div class="timestamp-time timestamp-data">{{ filoData?.sapporoFilo?.lastOut?.time_out ? formatTime(filoData?.sapporoFilo?.lastOut?.time_out, 'time') : '&nbsp;' }}</div>
        <div class="timestamp-date timestamp-data">{{ filoData?.sapporoFilo?.lastOut?.time_out ? formatTime(filoData?.sapporoFilo?.lastOut?.time_out, 'date') : '&nbsp;' }}</div>
      </div>
    </div>
    <ng-template #noSapporoStaffs>
      <h4>No staffs to show</h4>
    </ng-template>
  </div>
  <div class="data-wrapper" [class.empty-data-wrapper]="!filoData?.fukuokaFilo?.firstIn && !filoData?.fukuokaFilo?.lastOut">
    <div class="row">
      <!-- <div class="table-header">拠点</div> -->
      <div class="table-header">福岡支店</div>
    </div>
    <div *ngIf="filoData?.fukuokaFilo?.firstIn || filoData?.fukuokaFilo?.lastOut; else noFukuokaStaffs">
      <div class="row">
        <div class="table-side-header">最初に出勤した人</div>
        <div class="timestamp-staff timestamp-data">{{ filoData?.fukuokaFilo?.firstIn?.staff_name ? filoData?.fukuokaFilo?.firstIn?.staff_name : '&nbsp;' }}</div>
        <div class="timestamp-time timestamp-data">{{ filoData?.fukuokaFilo?.firstIn?.time_in ? formatTime(filoData?.fukuokaFilo?.firstIn?.time_in, 'time') : '&nbsp;' }}</div>
        <div class="timestamp-date timestamp-data">{{ filoData?.fukuokaFilo?.firstIn?.time_in ? formatTime(filoData?.fukuokaFilo?.firstIn?.time_in, 'date') : '&nbsp;' }}</div>
      </div>
      <div class="row">
        <div class="table-side-header">最後に退勤した人</div>
        <div class="timestamp-staff timestamp-data">{{ filoData?.fukuokaFilo?.lastOut?.staff_name ? filoData?.fukuokaFilo?.lastOut?.staff_name : '&nbsp;' }}</div>
        <div class="timestamp-time timestamp-data">{{ filoData?.fukuokaFilo?.lastOut?.time_out ? formatTime(filoData?.fukuokaFilo?.lastOut?.time_out, 'time') : '&nbsp;' }}</div>
        <div class="timestamp-date timestamp-data">{{ filoData?.fukuokaFilo?.lastOut?.time_out ? formatTime(filoData?.fukuokaFilo?.lastOut?.time_out, 'date') : '&nbsp;' }}</div>
      </div>
    </div>
    <ng-template #noFukuokaStaffs>
      <h4>No staffs to show</h4>
    </ng-template>
  </div>
  <div class="data-wrapper" [class.empty-data-wrapper]="!filoData?.cebuFilo?.firstIn && !filoData?.cebuFilo?.lastOut">
    <div class="row">
      <!-- <div class="table-header">拠点</div> -->
      <div class="table-header">セブ支店</div>
    </div>
    <div *ngIf="filoData?.cebuFilo?.firstIn || filoData?.cebuFilo?.lastOut; else noCebuStaffs">
      <div class="row">
        <div class="table-side-header">最初に出勤した人</div>
        <div class="timestamp-staff timestamp-data">{{ filoData?.cebuFilo?.firstIn?.staff_name ? filoData?.cebuFilo?.firstIn?.staff_name : '&nbsp;' }}</div>
        <div class="timestamp-time timestamp-data">{{ filoData?.cebuFilo?.firstIn?.time_in ? formatTime(filoData?.cebuFilo?.firstIn?.time_in, 'time') : '&nbsp;' }}</div>
        <div class="timestamp-date timestamp-data">{{ filoData?.cebuFilo?.firstIn?.time_in ? formatTime(filoData?.cebuFilo?.firstIn?.time_in, 'date') : '&nbsp;' }}</div>
      </div>
      <div class="row">
        <div class="table-side-header">最後に退勤した人</div>
        <div class="timestamp-staff timestamp-data">{{ filoData?.cebuFilo?.lastOut?.staff_name ? filoData?.cebuFilo?.lastOut?.staff_name : '&nbsp;' }}</div>
        <div class="timestamp-time timestamp-data">{{ filoData?.cebuFilo?.lastOut?.time_out ? formatTime(filoData?.cebuFilo?.lastOut?.time_out, 'time') : '&nbsp;' }}</div>
        <div class="timestamp-date timestamp-data">{{ filoData?.cebuFilo?.lastOut?.time_out ? formatTime(filoData?.cebuFilo?.lastOut?.time_out, 'date') : '&nbsp;' }}</div>
      </div>
    </div>
    <ng-template #noCebuStaffs>
      <h4>No staffs to show</h4>
    </ng-template>
  </div>
</ng-template>
